"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var admissionRequirements_1 = require("../admissionRequirements");
var admissionRequirementsConfig = {
    wherewego: {
        requirements: admissionRequirements_1.wwgRequirements,
        requirementsOptions: admissionRequirements_1.wwgRequirementsOptions,
        requirementsIcon: admissionRequirements_1.wwgRequirementsIcon,
    },
    skillup: {
        requirements: admissionRequirements_1.skillUpRequirements,
        requirementsOptions: admissionRequirements_1.skillUpRequirementsOptions,
        requirementsIcon: 'https://res.cloudinary.com/wherewego/image/upload/v1652675880/project-connect/bqm6fueaep5efz4qagdq.svg',
    },
};
exports.default = admissionRequirementsConfig;
